<template>
    <p class="form_steps">Paso {{ stepNum }}/{{ totalSteps }}</p>
</template>

<script>

export default {
    name: 'StepNumber',
    props: [
        'stepNum',
        'totalSteps'
    ]
}
</script>

<style>
    .form_steps {  
        display: inline-block;
        background-color: var(--info-light) ;
        font-size: 12px;    
        padding: 4px 8px;
        margin: 0px 0px 16px;
        border-radius: 4px;
    }
</style>